import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
const PORTFOLIO_IMAGES = 'portfolioImages'

const initialState = {
	entities: {},
	isLoading: false,
}

function prepConfig(getState) {
	const {
		userLogin: { userInfo },
	} = getState()

	return {
		headers: {
			Authorization: `Bearer ${userInfo.token}`,
		},
	}
}

export const getPortfolioImages = createAsyncThunk(
	`${PORTFOLIO_IMAGES}/getNotes`,
	async (portfolioId, { getState, rejectWithValue }) => {
		try {
			const { data } = await axios.get(`/api/portfolioImages/${portfolioId}`, prepConfig(getState))
			return data
		} catch (error) {
			console.error(error)
			return rejectWithValue('Failed to get images')
		}
	},
)

export const createPortfolioImage = createAsyncThunk(
	`${PORTFOLIO_IMAGES}/create`,
	async (portfolioImage, { getState, rejectWithValue }) => {
		try {
			const { data } = await axios.post(
				`/api/portfolioImages`,
				portfolioImage,
				prepConfig(getState),
			)
			return data
		} catch (error) {
			return rejectWithValue('Failed to get notes')
		}
	},
)

export const updatePortfolioImage = createAsyncThunk(
	`${PORTFOLIO_IMAGES}/update`,
	async (portfolioImage: any, { getState, rejectWithValue }) => {
		try {
			const { data } = await axios.put(
				`/api/portfolioimages/${portfolioImage._id}`,
				portfolioImage,
				prepConfig(getState),
			)
			return data
		} catch (error) {
			return rejectWithValue('Failed to update image')
		}
	},
)

export const deletePortfolioImage = createAsyncThunk(
	`${PORTFOLIO_IMAGES}/delete`,
	async (imageid: any, { getState, rejectWithValue }) => {
		try {
			const { data } = await axios.put(`/api/portfolioimages/${imageid}/delete`, {}, prepConfig(getState))
			return data
		} catch (error) {
			return rejectWithValue('Failed to create center')
		}
	},
)

// Extract the key out of the entitiy object
// eslint-disable-next-line no-unused-vars
const removeKey = (key, { [key]: _, ...rest }) => rest

const portfolioImageSlice = createSlice({
	name: 'portfolioImages',
	initialState,
	reducers: {},
	extraReducers: {
		[getPortfolioImages.fulfilled as any]: (state, action) => {
			const images = action.payload
			const imageMap = images.reduce((lookup, item) => {
				lookup[item._id] = item
				return lookup
			}, {})
			state.entities = { ...state.entities, ...imageMap }
			state.isLoading = false
		},
		[getPortfolioImages.pending as any]: state => {
			state.isLoading = true
		},
		[createPortfolioImage.fulfilled as any]: (state, action) => {
			const newNote = action.payload
			state.entities[newNote._id] = newNote
		},
		[updatePortfolioImage.fulfilled as any]: (state, action) => {
			const image = action.payload
			state.entities[image._id] = image
		},
		[deletePortfolioImage.fulfilled as any]: (state, action) => {
			const imageId = action.meta.arg
			state.entities = removeKey(imageId, state.entities)
		},
	} as any,
})

export default portfolioImageSlice

// export const { } = portfoliosSlice.actions;
